import { LangCode } from "@/modules/shared/hooks/useChangeLang";
import { routing } from "./routing";

export function detectClientLocale() {
    // Get browser language (fallback to "en")
    const browserLang = navigator.language;
  
    // Normalize to base language (e.g. "en-US" → "en")
    const baseLang = browserLang.split("-")[0].toLowerCase() as LangCode;
  
    // Return match if supported, otherwise fallback
    return routing.locales.includes(baseLang) ? baseLang : routing.defaultLocale;
  } 